import EnumSet from 'Services/enumSet'

interface IQuotationOrigin extends EnumSet {
  none: number
  coteiBem: number
  financing: number
  cross: number
  requotation: number
  sindicoNet: number
  partners: number
  quintoAndar: number
  noknox: number
}

const quotationOrigin = new EnumSet({
  none: { value: 0, description: 'Sem origem' },
  coteiBem: { value: 1, description: 'CoteiBem' },
  financing: { value: 2, description: 'Financiamento' },
  cross: { value: 3, description: 'Agregada' },
  requotation: { value: 4, description: 'Recotar' },
  sindicoNet: { value: 5, description: 'SindicoNet' },
  partners: { value: 6, description: 'Parcerias' },
  quintoAndar: { value: 7, description: 'QuintoAndar' },
  noknox: { value: 8, description: 'Noknox' },
  pack: { value: 9, description: 'Pacote' },
  integration: { value: 10, description: 'Integração' }
}) as IQuotationOrigin

export default quotationOrigin